module.exports = __webpack_public_path__ + "images/content/ec2.png";